import { Checkbox, List, ListItem, ListItemIcon, ListItemText, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useScheme } from '../../hooks/CompanyConfiguration/useScheme'

import { formatDate, formatNumber, handleSelectAllClick, handleSelectedItem, isSelected, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'
import { AiOutlineArrowRight, AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'
import CustomDialog from '../../components/CustomDialog'
import HeadingWithCloseIcon from '../../components/HeadingWithCloseIcon'
import ListDialog from '../../components/Dialog/ListDialog'

function Schemes() {
  const { schemes } = useContext(ConfigurationContext)
  const { getAllScheme, deleteScheme, deleteManyScheme, BulkUpload, loading } = useScheme()
  //console.log('SCHEMES : ', schemes)
  const [uploadedfile, setUploadedFile] = React.useState('')

  const [searchQuery, setSearchQuery] = useState('')
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState([])
  const [contentHeading, setContentHeading] = useState('')
  const filterScheme = schemes ? schemes.filter((scheme) => scheme && scheme.name.toLowerCase().includes(searchQuery.toLowerCase())) : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const noOfPages = Math.ceil(filterScheme && filterScheme.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }
  //console.log('SELECTED ITEM : ', selected)
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    getAllScheme({
      // page: page, limit: 10
    })
  }, [page])

  const heading = [
    { label: 'Name', key: 'name' },
    { label: 'Scheme Code', key: 'schemeCode' },
    { label: 'Category', key: 'category' },
    { label: 'Total Products', key: 'products' },
    { label: 'Total Stores', key: 'stores' },
  ]
  let tempScheme = []
  filterScheme &&
    filterScheme.forEach((item) =>
      tempScheme.push({
        name: item.name,
        schemeCode: item.schemeCode,
        category: item.category && item.category.categoryName,
        products: item.products.length,
        stores: item.store.length,
      })
    )

  const tempHeaders = [
    { label: 'schemeCode' },
    { label: 'name' },
    { label: 'categoryCode' },
    { label: 'sku' },
    { label: 'storeCode' },
    { label: 'noOfMonths' },
    { label: 'schemeStartDate' },
    { label: 'schemeType' },
    { label: 'saleAmount' },
    { label: 'incentive' },
    { label: 'schemeFor' },
  ]
  const bulkUpload = () => {
    const formData = new FormData()
    formData.append('file', uploadedfile)
    formData.append('sheetName', 'scheme')
    BulkUpload(formData)
    // setOpenPopup(false)
    setUploadedFile('')
  }

  return (
    <Layout
      heading="Scheme"
      url={ROUTES.ADD_SCHEME}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-scheme/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      // none
      // addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      tempHeaders={tempHeaders}
      headers={heading}
      data={tempScheme ? tempScheme : []}
      tempHeaderData={[]}
      filename="schemes"
      sampleName="sample_schemes"
      bulkUpload={bulkUpload}
      uploadedfile={uploadedfile}
      setFile={setUploadedFile}
    >
      <ListDialog array={content} handleClose={() => setOpen(false)} open={open} heading={contentHeading} name={'name'} field2={contentHeading === 'Products' ? 'sku' : 'storeCode'} />
      <CustomTable>
        {filterScheme.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < filterScheme.length}
                checked={filterScheme.length > 0 && selected.length === filterScheme.length}
                onClick={(event) => handleSelectAllClick(event, filterScheme, setSelected)}
              />,
              'name',
              'Code',
              'category',
              'Products',
              'stores',
              'incentive',
              'created date',
              'info',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            filterScheme.length > 0 &&
            filterScheme.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>

                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.schemeCode}</TableCell>
                  <TableCell>{item.category && item.category.length > 0 ? item.category[0].categoryName : '----'}</TableCell>
                  <TableCell
                    onClick={() => {
                      setOpen(true)
                      setContent(item && item.products)
                      setContentHeading('Products')
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {item.products.length}
                  </TableCell>
                  <TableCell
                    onClick={() => {
                      setOpen(true)
                      setContent(item && item.store)
                      setContentHeading('Stores')
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {item.store.length}
                  </TableCell>
                  <TableCell>{formatNumber(item.incentive ? item.incentive : 0)}</TableCell>
                  <TableCell>{formatDate(item.createdAt)}</TableCell>
                  <TableCell>
                    <AiOutlineInfoCircle style={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => history.push(`/view-scheme/${item._id}`)} />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteScheme({ schemeId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyScheme({ schemeId: multipleId }, setSelected)}
      />
      {!loading && filterScheme.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {loading && <Loader />}
      {!loading && !filterScheme.length && <NoDataFound />}
    </Layout>
  )
}

export default Schemes
